<template lang="pug">
div 
  b-modal(:active="isSelectCollectionModalOpened", has-modal-card)
    .modal-card
      .modal-card-head
        p.modal-card-title Save record(s) to a collection
      .modal-card-body
        b-field(label="Select a collection")
        b-select(placeholder="Collection", v-model="uiSelectedCollectionId")
          option(v-for="item in collections", :key="item.id", :value="item.id") {{ item.name }}

      .modal-card-foot
        .container
          .level
            .level-left
              .level-item
                b-button(type="is-primary", @click="uiSaveRecord") Save records
                b-button(type="is-danger", @click="closeModal") Cancel
            .level-right
              .level-item
                b-button(
                  type="is-primary",
                  icon-left="magic",
                  @click="openCreateCollectionModal"
                ) Create new Collection
</template>
<script>
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
export default {
  computed: {
    ...mapState("collection", {
      collections: (s) => s.rawCollections,
    }),
    ...mapState("saveRecord", {
      selectedCollectionId: (s) => s.selectedCollectionId,
      isSelectCollectionModalOpened: (s) => s.isModalOpened,
    }),
    ...mapGetters("fetchPaper", ["papers"]),
    uiSelectedCollectionId: {
      get() {
        return this.selectedCollectionId;
      },
      set(value) {
        this.selectCollection(value);
      },
    },
  },
  methods: {
    ...mapMutations("saveRecord", ["closeModal", "selectCollection"]),
    ...mapMutations('fetchPaper', ['deselectAllRecords']),
    ...mapMutations("createCollection", {
      openCreateCollectionModal: "openModal",
    }),
    async uiSaveRecord() {
      if (this.selectedCollectionId === null) return;

      const reqBody = { collectionId: this.selectedCollectionId };

      const selectedPapers = this.papers.filter((x) => x.selected === true);
      reqBody.data = selectedPapers.map((x) => {
        return {
          title: x.title,
          authors: x.authors,
          publication: x.presentPlace,
          year: x.year,
          website: x.website,
          citeNum: x.cite,
          linkToCitation: x.linkToCitation,
          apa: x.apa,
          bibtex: x.bibtex,
        };
      });
      const success = await this.saveRecord(reqBody);
      if (success) {
        this.closeModal();
        this.openSuccessSnackbar("Saved record(s) to the collection");
        this.deselectAllRecords()
      } else {
        this.openErroSnackbar("Error! Please try again later");
      }
    },
    ...mapActions("saveRecord", ["saveRecord"]),
  },
};
</script>